import React, { useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

function ViewBroadcastNotification({ broadcast, userLength }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const userListName = () => {
    if (userLength === broadcast?.userId?.length || broadcast?.userId?.length === 0) {
      return "All Users";
    } else {
      return broadcast?.userId?.length > 0
        ? broadcast?.userId
            ?.map((user) => `${user.firstName} ${user.lastName}`)
            ?.join(", ")
        : "-";
    }
  };

  return (
    <>
      <OverlayTrigger
        key="top"
        placement="top"
        overlay={<Tooltip id="tooltip-top">View</Tooltip>}
      >
        <img
          src="/images/png/view.png"
          onClick={handleShow}
          className="pointer"
          width={35}
          alt="action"
        />
      </OverlayTrigger>

      <Modal
        show={show}
        className="custom-modal"
        size="lg"
        centered
        scrollable
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>View Broadcast Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row g-3">
            <div className="col-12">
              <Form.Label className="mb-0">Title</Form.Label>
              <p>{broadcast.title}</p>
            </div>
            <div className="col-12">
              <Form.Label className="mb-0">Schedule Time</Form.Label>
              <p>
                {broadcast.scheduleTime
                  ? new Date(broadcast.scheduleTime)
                      .toLocaleString()
                      .split("T")[0]
                  : "-"}
              </p>
            </div>
            <div className="col-12">
              <Form.Label className="mb-0">Created Date</Form.Label>
              <p>
                {broadcast.createdAt
                  ? new Date(broadcast.createdAt).toLocaleString().split("T")[0]
                  : "-"}
              </p>
            </div>
            <div className="col-12">
              <Form.Label className="mb-0">Send</Form.Label>
              <p>{broadcast.isSend === 1 ? "Yes" : "No"}</p>
            </div>
            <div className="col-12">
              <Form.Label className="mb-0">Description</Form.Label>
              <p>{broadcast.desc ? broadcast.desc : "-"}</p>
            </div>
            <div className="col-12">
              <Form.Label className="mb-0">Users</Form.Label>
              <p>{userListName()}</p>
            </div>
            <div className="col-12">
              <Form.Label className="mb-0">Recipe blog</Form.Label>
              <p>{broadcast?.blogId ? broadcast?.blogId?.title : "-"}</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ViewBroadcastNotification;
